// API helper for the SaaS subscription module. Mirrors modulesApi.js:
// config.API_BASE_URL (already ends with /api) + JWT from sessionStorage.
import axios from 'axios';
import config from '../../config';

const api = axios.create({ baseURL: config.API_BASE_URL });

api.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem('token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Current company id from the logged-in session.
export const getCompanyId = () => {
  const company = JSON.parse(sessionStorage.getItem('companyDetails') || '{}');
  return company?.id || 0;
};

export const subscriptionApi = {
  // Plans (master)
  // Pass companyId to get what THAT customer may buy, at the price agreed
  // with them. Omit it for the universal price list, which is what the
  // admin's plan-master screen wants.
  getPlans: (activeOnly = false, propertType, companyId) =>
    api.get('/Subscription/plans', {
      params: { activeOnly, propertType, companyId },
    }),

  // Company plan offers — HotelDesk admin only.
  getCompanyOffers: (companyId) =>
    api.get(`/Subscription/company-offers/${companyId}`),
  saveCompanyOffers: (dto) => api.post('/Subscription/company-offers', dto),
  savePlan: (dto) => api.post('/Subscription/plans', dto),
  togglePlan: (planId, isActive) =>
    api.post('/Subscription/plans/toggle', null, { params: { planId, isActive } }),

  // Company subscription
  getStatus: (companyId) => api.get(`/Subscription/status/${companyId}`),
  // Plan-wise menu access — { hasActivePlan, allMenus, menuKeys }.
  getCompanyMenus: (companyId) =>
    api.get(`/Subscription/company-menus/${companyId}`),
  subscribe: (dto) => api.post('/Subscription/subscribe', dto),
  startTrial: (companyId) => api.post(`/Subscription/start-trial/${companyId}`),
  getHistory: (companyId) => api.get(`/Subscription/history/${companyId}`),

  // Payments
  recordPayment: (dto) => api.post('/Subscription/payment', dto),
  getPayments: (subscriptionId) =>
    api.get(`/Subscription/payments/${subscriptionId}`),
  // Report: all subscription payments for a company (optional date range).
  getPaymentReport: (companyId, from, to) =>
    api.get(`/Subscription/payment-report/${companyId}`, { params: { from, to } }),

  // Add-ons (Hotel only) — master list + what a company owns.
  getAddons: (activeOnly = false) =>
    api.get('/Addon/list', { params: { activeOnly } }),
  getCompanyAddons: (companyId) => api.get(`/Addon/company/${companyId}`),

  // CC Avenue — returns { gatewayUrl, encRequest, accessCode } to auto-submit.
  initiateCCAvenue: (companyId, planId, addonIds = []) =>
    api.post('/Subscription/ccavenue/initiate', { companyId, planId, addonIds }),

  // AllUPI — returns { success, message, paymentUrl, orderRef, amount }.
  initiateAllUpi: (companyId, planId, addonIds = []) =>
    api.post('/Subscription/allupi/initiate', { companyId, planId, addonIds }),
  // Polled while the QR is shown — { status, message }.
  getAllUpiOrderStatus: (orderRef) =>
    api.get('/Subscription/allupi/order-status', { params: { orderRef } }),
};

export default api;
